import React from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { persistantLogin } from "../actions";

const LoginRoute = ({ component: Comp, loggedIn, path, ...rest }) => {
    let { auth } = rest;

    /*if (
        typeof getLocalStorage('login_dt') !== 'undefined' && 
        getLocalStorage('login_dt') != null
    ) {    
        const _date = new Date();
        const _expire = Number(getLocalStorage('login_dt'));
        const _now = Number(Date.parse(_date));
        
        if (_now < _expire) {
            // persistantLogin();
            auth = true;
        }
    }*/

    return (
        <Route
            {...rest}
            // path={path}

            render={props => {
                return !auth ? (
                    <Comp {...props} />
                ) : (
                    <Redirect to="/splash" {...props} />
                );
            }}
        />
    );
};

const mapStateToProps = state => {
    const { auth, user_details } = state.auth;
    return {
        auth
    };
};

export default connect(mapStateToProps)(LoginRoute);
